<template>
    <div class="container">
        <content-header title="Страничка психотерапевта"/>
        <p>
            <strong>«Здравствуйте!»</strong> — привычное и всем хорошо известное приветствие, — пожелание здоровья. Но,
            к сожалению,
            очень привычное из-за частого употребления иногда теряет свой смысл. В работе врача иногда бывают случаи,
            когда необязательны дорогие лекарства и сложные методы лечения, достаточно лишь суметь напомнить человеку о
            чём-то важном для него, но как-то подзабытом из-за сует и проблем. Иногда. И напомнить надо суметь. Так,
            чтобы осознание проблемы помогло предотвратить симптомы…
        </p>
        <p>Для того мы и открываем СТРАНИЧКУ ПСИХОТЕРАПЕВТА, чтобы поговорив о простых, вроде бы, знакомых вещах,
            желательно доступным, не академичным языком, напомнить о чём-то важном и ценном, знакомом, но слегка забытом
            — О СВОЁМ ТЕЛЕСНОМ И ДУШЕВНОМ ЗДОРОВЬЕ. Не только и не столько для информирования, — доступной информации о
            проблемах и симптомах сейчас достаточно, но именно с целью обращения внимания на возможности и
            неиспользованные ресурсы.</p>
        <p>«Перестать болеть, или начать выздоравливать?», «лечить болезнь, или укреплять своё здоровье?», «решать
            задачу полноценного отдыха, или заниматься проблемой последствия производственных стрессов и перегрузок?»,
            «может ли удовольствие быть здоровым?», — темы и вопросы, которые мы хотим обязательно затронуть на нашей
            страничке в ближайшей перспективе. Так что, ЗДРАВСТВУЙТЕ, делайте, пожалуйста, это С УДОВОЛЬСТВИЕМ и
            посещайте иногда нашу СТРАНИЧКУ ПСИХОТЕРАПЕВТА!</p>
        <div class="divider"></div>
        <div class="row">
            <div class="col">
                <div class="box">
                    <img src="../../assets/images/staticPages/psih2s-300x240.jpg" alt="psih2s" height="240"
                         width="300"/>
                    <router-link :to="{name: 'Утро Вечера Мудренее'}" class="link"><span>«УТРО ВЕЧЕРА МУДРЕНЕЕ»</span>
                    </router-link>
                </div>
            </div>
            <div class="col">
                <div class="box">
                    <img src="../../assets/images/staticPages/psih1s-300x231.jpg" alt="psih1s" height="231"
                         width="300"/>
                    <router-link :to="{name: 'Учиться радоваться жизние'}" class="link"><span>«РАДОВАТЬСЯ ЖИЗНИ»</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="inv-divider"></div>
        <div class="row">
            <div class="col">
                <div class="box">
                    <img src="../../assets/images/staticPages/NEWS_025-300x200.jpg" alt="NEWS_025" height="200"
                         width="300"/>
                    <router-link :to="{name: 'Нарушения пищевого поведения'}" class="link"><span>Психотерапия – важная часть лечения ожирения</span>
                    </router-link>
                </div>
            </div>
            <div class="col">
                <div class="box">
                    <img src="../../assets/images/staticPages/stress254-300x132.jpg" alt="stress254" height="132"
                         width="300"/>
                    <router-link :to="{name: 'Психосоматические расстройства, как реакция на психосоциальный стресс'}"
                                 class="link"><span>ПСИХО-СОЦИАЛЬНЫЙ СТРЕСС</span></router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "psychotherapy",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: block;
    text-align: center;
    width: 300px;
    margin: 0 auto;
}

.link {
    color: #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
    margin: 0 auto;
}

.link > span {
    font-size: 14px;
    border-bottom: 1px dotted #006688;
}

.left-30px {
    margin-left: 30px;
}

.row {
    display: flex;
    width: 100%;
}

.col {
    display: inline-block;
    width: 50%;
}

</style>
